import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export const InAppAnnouncementCypressAttribute: CypressAttribute = {
  buttons: {
    GOT_IT: 'InAppAnnouncementCypressAttribute:buttons:GOT_IT',
    ADD_ANNOUNCEMENT: 'InAppAnnouncementCypressAttribute:buttons:ADD_ANNOUNCEMENT',
    PUBLISH: 'InAppAnnouncementCypressAttribute:buttons:PUBLISH',
    SAVE_DRAFT: 'InAppAnnouncementCypressAttribute:buttons:SAVE_DRAFT',
    CANCEL: 'InAppAnnouncementCypressAttribute:buttons:CANCEL',
    PREVIEW: 'InAppAnnouncementCypressAttribute:buttons:PREVIEW',
    EDIT: 'InAppAnnouncementCypressAttribute:buttons:EDIT',
    JURISDICTION_SCOPE: 'InAppAnnouncementCypressAttribute:buttons:JURISDICTION_SCOPE',
    OPEN_RELEASE_UPDATES: 'InAppAnnouncementCypressAttribute:buttons:OPEN_RELEASE_UPDATES',
    ROLE_SCOPE: 'InAppAnnouncementCypressAttribute:buttons:ROLE_SCOPE',
    DELETE: 'InAppAnnouncementCypressAttribute:buttons:DELETE',
    BILLING_PLAN_SCOPE: 'InAppAnnouncementCypressAttribute:buttons:BILLING_PLAN_SCOPE'
  },
  inputs: {
    TITLE: 'InAppAnnouncementCypressAttribute:inputs:TITLE',
    DESCRIPTION: 'InAppAnnouncementCypressAttribute:inputs:DESCRIPTION',
    RELEASE_DATE: 'InAppAnnouncementCypressAttribute:inputs:RELEASE_DATE',
    CONTENT_TYPE: 'InAppAnnouncementCypressAttribute:inputs:CONTENT_TYPE',
    SCRIBE_SOURCE: 'InAppAnnouncementCypressAttribute:inputs:SCRIBE_SOURCE',
    IMAGE: 'InAppAnnouncementCypressAttribute:inputs:IMAGE',
    URL_SCOPE: 'InAppAnnouncementCypressAttribute:inputs:URL_SCOPE',
    SELECT_JURISDICTIONS: 'InAppAnnouncementCypressAttribute:inputs:SELECT_JURISDICTIONS',
    SELECT_PROFESSIONS: 'InAppAnnouncementCypressAttribute:inputs:SELECT_PROFESSIONS',
    SELECT_ESTATE_ROLES: 'InAppAnnouncementCypressAttribute:inputs:SELECT_ESTATE_ROLES',
    SELECT_BILLING_PLANS: 'InAppAnnouncementCypressAttribute:inputs:SELECT_BILLING_PLANS'
  },
  views: {
    CAROUSEL: 'InAppAnnouncementCypressAttribute:views:CAROUSEL',
    IN_APP_ANNOUNCEMENT: 'InAppAnnouncementCypressAttribute:views:IN_APP_ANNOUNCEMENT',
    ANNOUNCEMENT_TABLE: 'InAppAnnouncementCypressAttribute:views:ANNOUNCEMENT_TABLE'
  }
};
